import Form from 'react-bootstrap/Form'

import Icon from '@/components/Icon/Icon'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'

const DarkModeSlider = () => {
  const [theme, setTheme] = useTheme()
  const isDarkMode = theme === 'dark'
  return (
    <Form.Switch
      checked={isDarkMode}
      id='dark-mode'
      label={<Icon icon={isDarkMode ? 'moon' : 'sun'} />}
      onChange={() => setTheme(isDarkMode ? 'light' : 'dark')}
    />
  )
}

export default DarkModeSlider
